import axios from "../../../api/axios";
import {AxiosRequestConfig} from "axios";
import {configNew} from "../../../config";

const config = (): AxiosRequestConfig => {
  return {
    ...configNew()
  }
}

export const apiArticles = (body: any) => axios.get(`/article/list`,
    {
      params: body,
      ...config()
    }).then(({data}) => data);

export const apiAuthors = (body: any) => axios.get(`/article/authors`,
    {
    params: body,
    ...config()
    }).then(({data}) => data);

export const apiRegions = (body: any) => axios.get(`/lists/regions`,
      {
      params: body,
      ...config()
      }).then(({data}) => data);

export const apiKindergartens = (body: any) => axios.get(`/lists/kindergartens`,
      {
      params: body,
      ...config()
      }).then(({data}) => data);

export const apiGetThemeList = (body: any) => axios.get(`/article/themes`,
      {
      params: body,
      ...config()
      }).then(({data}) => data);

export const apiGetArticleList = (body?: any) =>
  axios
    .get(`/article/list`, {
      params: body,
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetAutorsList = (body?: any) =>
  axios
    .get(`/article/authors`, {
      params: body,
      ...config(),
    })
    .then(({ data }) => data);
